import { Container } from "@/types/customPage";
import { navigationStore } from "@/store/pinia_modules/navigationStore";

export async function doActionHelper(container: Container, keyUp?: boolean) {
    if (container.actions && container.actions.length > 0) {
        // sort actions by index ascending
        const actions = container.actions.sort(
            (a, b) => (a?.index ?? 0) - (b?.index ?? 0)
        );
        for (const a of actions) {
            if (keyUp) {
                if (
                    a.value == "signin-request-code" ||
                    a.value == "signup" ||
                    a.value == "submit-pin"
                ) {
                    await navigationStore().emitAction(a);
                }
            } else {
                await navigationStore().emitAction(a);
            }
        }
    } else if (container.action) {
        if (keyUp) {
            if (
                container.action.value == "signin-request-code" ||
                container.action.value == "signup" ||
                container.action.value == "submit-pin"
            ) {
                await navigationStore().emitAction(container.action);
            }
        } else {
            await navigationStore().emitAction(container.action);
        }
    }
}
